export const WAEC_CITIZENSHIP_LEARN_SS1 = [];